import { ExternalAuthData } from "./ExternalAuthContext";

class ExternalAuthStore {
  private authData: ExternalAuthData | null = null;

  setAuthData(data: ExternalAuthData | null) {
    this.authData = data;
  }

  getAuthData(): ExternalAuthData | null {
    return this.authData;
  }

  getAccessToken(): string | undefined {
    return this.authData?.accessToken;
  }

  getIdToken(): string | undefined {
    return this.authData?.idToken;
  }

  isExternalAuthActive(): boolean {
    return this.authData !== null && !!this.authData.accessToken;
  }
}

export const externalAuthStore = new ExternalAuthStore();
